import React, { useEffect, useState } from "react";
import DownloadCountryPoliciesResponses from '../../../services/downloadCountryPoliciesResponsesTable.jsx';
import Button from 'react-bootstrap/Button';
import { exportMultipleChartsToPdf } from '../../../services/exportGraphsToPdf';
import { useTranslation } from 'react-i18next';


function DownloadDataRegional(props) {
const { t } = useTranslation();

   



  const [dataFromServer, setDataFromServer] = useState("");
  const[jsonLoaded, setLoad] = useState(false);


  useEffect(() => {
   
   
    
  
   
  
    const fetchData = async () => {
      if(jsonLoaded === false) {
      
          
         
            fetch(`${process.env.REACT_APP_BACKEND_API}/submission/report/all/`, {
             method: "GET",
              headers: {
              "accept": "application/json",
                 "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
              },
    })
      .then((response) => response.json())
      .then((data) => {
        setDataFromServer(data);
       
      })
      .catch((error) => console.log(error));
           setLoad(true);
           
  
      
      }
    };
  
    fetchData();
  }, [props.lang, jsonLoaded]);

    return (

    <React.Fragment>   
         <br></br>
         <br></br>
      {dataFromServer !== undefined && dataFromServer.length > 0 ?
     <div className="App" style={{display: "flex", justifyContent: "flex-end"}}>
     <span> <DownloadCountryPoliciesResponses type={"policies"} page={"allData"} data={dataFromServer}/></span> 
      <span>   <Button  onClick={exportMultipleChartsToPdf} style={{marginLeft: "10px", marginRight:"10px", backgroundColor: "#116AAB",  border:"1px solid #116AAB"}}>
      <span style={{marginLeft: "0.5rem", marginRight: "0.5rem", verticalAlign: "middle"}}>
        {t('download_charts')}
        </span>
      {/* <img style={{verticalAlign: "middle"}} src={process.env.PUBLIC_URL + `/img/download.svg`} alt="download" /> */}
      </Button></span> 
    </div>
     : <div></div>} 
    {/* <iframe title="regional" style={{marginTop: "3rem", width: "1040px", height: "991px"}} src="https://tableau.apps.fao.org/#/views/PolicyresponsesofcountriestotheGlobalPlanofActionfortheConservationSustainableUseandDevelopmentofFGR/PolicyResponses_Regional_1/847a8317-a02d-4741-8bad-9e30ecc6d191/Regional?:iid=1?:showVizHome=no&:embed=true"></iframe>    */}
    {/* <tableau-viz style={{marginTop: "3rem", width: "1040px", height: "1991px"}} id="tableauViz"       
  src='https://tableau.apps.fao.org/views/FGR_Policy_Response/PolicyResponses_Regional/0edbe37a-fdf2-41f5-b14e-a96bae8709de/FGR_Policy_Response_Regional:showVizHome=no&:embed=true'      
  toolbar="hidden" hide-tabs>
</tableau-viz>  */}
{/* <Tableau type={props.type} /> */}
    
      </React.Fragment>




   
  );
}
  export default DownloadDataRegional;